import React from "react";

const ReservationInitLoader = () => {
    return (
        <div className="container mb-5 front-reservation-loader">
            <div className="front-reservation-loader__text">
                Even geduld alstublieft, wij laden je reservering.
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="front-reservation-skeleton">
                        <div className="front-skeleton-block front-skeleton-block--title" />
                        <div className="front-skeleton-block front-skeleton-block--card" />
                        <div className="front-skeleton-block front-skeleton-block--title" />
                        <div className="front-skeleton-block front-skeleton-block--input" />
                        <div className="front-reservation-skeleton__row">
                            <div className="front-skeleton-block front-skeleton-block--input" />
                            <div className="front-skeleton-block front-skeleton-block--input" />
                        </div>
                        <div className="front-skeleton-block front-skeleton-block--notice" />
                        <div className="front-skeleton-block front-skeleton-block--line" />
                        <div className="front-skeleton-block front-skeleton-block--line" />
                        <div className="front-skeleton-block front-skeleton-block--line front-skeleton-block--line-short" />
                    </div>
                    <div className="front-reservation-skeleton front-reservation-skeleton--actions">
                        <div className="front-skeleton-block front-skeleton-block--btn" />
                        <div className="front-skeleton-block front-skeleton-block--btn front-skeleton-block--btn-primary" />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="front-reservation-skeleton front-reservation-skeleton--summary">
                        <div className="front-skeleton-block front-skeleton-block--title" />
                        <div className="front-skeleton-block front-skeleton-block--image" />
                        <div className="front-skeleton-block front-skeleton-block--row" />
                        <div className="front-skeleton-block front-skeleton-block--row" />
                        <div className="front-skeleton-block front-skeleton-block--row" />
                        <div className="front-skeleton-block front-skeleton-block--row" />
                        <div className="front-skeleton-block front-skeleton-block--row" />
                        <div className="front-skeleton-block front-skeleton-block--total" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReservationInitLoader;
